module.exports = __webpack_public_path__ + "media/images/ir/common/icon_facebook-abcef69bd221f4cfd06b6adc97c31f22.svg";